import React from 'react';
import { BadgeCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { OptimizedImage } from '../OptimizedImage';
import { images, BUYERS_COUNT } from '../../data/content';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-brand-950 text-white" data-id="element-290" data-mp="cujiy6tux9xl">
      <div className="mx-auto max-w-5xl px-5 pb-12 pt-8 text-center sm:pt-12 lg:pb-20" data-id="element-291" data-mp="hvqqc4s3873q">
        <h1 className="mx-auto max-w-4xl font-display text-[30px] font-extrabold leading-[1.08] tracking-tight sm:text-5xl lg:text-[58px]" data-id="element-292" data-mp="mszdkjs3f1bu">
          Llevá tu profesión al siguiente nivel trabajando con <span className="text-sun" style={{
          color: "#FFE17A"
        }} data-id="element-293" data-mp="vndoka5lbpp5">adultos mayores</span>
        </h1>
        <p className="mx-auto mt-4 max-w-3xl font-display text-base font-extrabold uppercase leading-snug tracking-wide text-brand-100 sm:text-xl" data-id="element-294" data-mp="10kdtuium8of7">
          Recursos prácticos para profesionales del movimiento y la actividad física
        </p>

        <OptimizedImage src={images.mockup} alt="Mockup de Reactiva tu Cuerpo: caja del programa, planillas de planificación, rutinas por nivel, laptop con los módulos, tablet y celular" width={1254} height={1254} priority className="mx-auto mt-6 aspect-square h-auto w-[70%] max-w-[434px] object-contain drop-shadow-[0_40px_50px_rgba(23,49,59,0.5)]" data-id="element-295" data-mp="1ahig0iogojw0" />

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white sm:text-lg" data-id="element-296" data-mp="3ruh2bg3g4sjc">
          Incorporá herramientas prácticas, ejercicios, actividades y rutinas adaptadas para trabajar con personas mayores y{' '}
          <strong className="font-semibold text-sun" style={{
          color: "#FFE17A"
        }} data-id="element-297" data-mp="nfzfpiz0uoga">ampliá los servicios que podés ofrecer.</strong>
        </p>

        <ul className="mx-auto mt-6 grid max-w-xl grid-cols-3 rounded-2xl bg-white/5 ring-1 ring-white/10" data-id="element-298" data-mp="en5ja8rg18f7">
          <li className="px-2 py-3" data-id="element-299" data-mp="1b5bowiucmwil">
            <p className="font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-300" data-mp="1b6cwgdc5p0vk">7</p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-301" data-mp="16c8te560hczr">Tomos</p>
          </li>
          <li className="relative border-l border-white/10 px-2 py-3" data-id="element-302" data-mp="35kqt27xyebzi">
            <span className="absolute -left-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-sun font-display text-xs font-extrabold text-ink" aria-hidden="true" style={{
            backgroundColor: "#F7C325",
            backgroundImage: "none"
          }} data-id="element-303" data-mp="35n3bsnbjcqdm">
              +
            </span>
            <p className="font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-304" data-mp="2hxim7lkvmuvd">5</p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-305" data-mp="27xrshm454jwc">Bonos</p>
          </li>
          <li className="relative border-l border-white/10 px-2 py-3" data-id="element-306" data-mp="2cxe6hxrsm467">
            <span className="absolute -left-2.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-sun font-display text-xs font-extrabold text-ink" aria-hidden="true" style={{
            backgroundColor: "#F7C325",
            backgroundImage: "none"
          }} data-id="element-307" data-mp="664yrcsv6aw6">
              +
            </span>
            <p className="flex items-center justify-center gap-1 font-display text-2xl font-extrabold leading-none text-sun sm:text-3xl" style={{
            color: "#FFE17A"
          }} data-id="element-308" data-mp="1qo7ee444m7zc">
              {BUYERS_COUNT}
              <BadgeCheckIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-label="Verificado" data-id="element-309" data-mp="20mdfwkm0tc3o" />
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-100" data-id="element-310" data-mp="2ecyz6afdzo23">Compradores</p>
          </li>
        </ul>

        <div className="mx-auto mt-7 flex max-w-md flex-col items-stretch gap-2.5 sm:max-w-none sm:items-center" data-id="element-311" data-mp="2abdgg8g68fjz">
          <CtaButton size="lg" data-id="element-312" data-mp="2oawluthllcsl" />
          <p className="flex items-center justify-center gap-2 text-sm text-brand-100" data-id="element-313" data-mp="2jcuu7k63w55i">
            <ZapIcon className="h-4 w-4 shrink-0 text-sun" aria-hidden="true" data-id="element-314" data-mp="txnbkzh89n9a" />
            Acceso digital inmediato • Material práctico y organizado
          </p>
        </div>
      </div>
    </section>;
}